module.exports = __webpack_public_path__ + "img/hk.d8c97368.svg";